module.exports = __webpack_public_path__ + "static/media/Black-Afgano-removebg-preview.3c691647.png";